import namedUrls from "@/urls.json";

interface NamedUrl {
  name: string;
  pattern: string;
}

export function resolveUrl(urlName: string, ...params: (string | number)[]): string {
  const urlPattern = (namedUrls as NamedUrl[]).find((url) => url.name === urlName);

  if (!urlPattern) {
    return "";
  }

  let pattern = urlPattern.pattern;

  if (!pattern.startsWith("/")) {
    pattern = "/" + pattern;
  }

  // manage (<type:name>)
  const typeRegex = /<(\w+):(\w+)>/g;
  pattern = pattern.replace(typeRegex, () => {
    const paramValue = params.shift();
    return paramValue !== undefined ? String(paramValue) : "";
  });

  // manage (<name>)
  const nameOnlyRegex = /<(\w+)>/g;
  pattern = pattern.replace(nameOnlyRegex, () => {
    const paramValue = params.shift();
    return paramValue !== undefined ? String(paramValue) : "";
  });

  return pattern;
}